const CHUNK_RELOAD_STORAGE_KEY = 'fe-admin-chunk-reload-attempted'

const CHUNK_LOAD_ERROR_PATTERN = /Failed to fetch dynamically imported module|Loading chunk [\d]+ failed|Importing a module script failed/i

const isChunkLoadFailure = (value: unknown): boolean => {
  const message = value instanceof Error ? value.message : String(value ?? '')
  return CHUNK_LOAD_ERROR_PATTERN.test(message)
}

/** Reload once when a lazy chunk 404s after deploy (stale tab or rolling update). */
export const registerChunkLoadRecovery = (): void => {
  if (typeof window === 'undefined') {
    return
  }

  const reloadOnce = (): void => {
    if (sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY)) {
      return
    }
    sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, '1')
    window.location.reload()
  }

  window.addEventListener('vite:preloadError', (event: Event) => {
    event.preventDefault()
    reloadOnce()
  })

  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadFailure(event.reason)) {
      return
    }
    event.preventDefault()
    reloadOnce()
  })

  window.addEventListener('load', () => {
    sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY)
  })
}
